import {DeleteDictionary, DeleteDictionaryValue, ListDictionary, ListDictionaryValue} from "@/api/dictionary";

const state = () => ({
  dictionaries: [],
  dictionary_values: [],
})

// getters
const getters = {}

// actions
const actions = {
  async fetchDictionaries( { commit, dispatch }, params) {
    await dispatch("loading/setLoading", true, {root: true})
    ListDictionary(params).then((data) => {
      let dictionaries = data.data.data
      commit('setDictionaries', dictionaries)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
  async fetchDictionaryValues( { commit, dispatch } ) {
    await dispatch("loading/setLoading", true, {root: true})
    ListDictionaryValue().then((data) => {
      let dictionary_values = data.data.data
      commit('setDictionaryValues', dictionary_values)
    }).catch((err) => {
      console.log(err)
    }).finally(async () =>{
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
    async deleteDictionary( { commit, dispatch } ,id) {
        await dispatch("loading/setLoading", true, {root: true})
        let parms = {ID:id}
        DeleteDictionary(parms).then(() => {

            ListDictionary().then((data) => {
                let dictionaries = data.data.data
                commit('setDictionaries', dictionaries)
            }).catch((err) => {
                console.log(err)
            }).finally(async () =>{
                await dispatch("loading/setLoading", false, {root: true})
            })

        }).catch((err) => {
            console.log(err)
        }).finally(async () =>{
            await dispatch("loading/setLoading", false, {root: true})
        })
    },

  async deleteDictionaryValue( { dispatch }, id ) {
    await dispatch("loading/setLoading", true, {root: true})
    let params = {ID: id}
    DeleteDictionaryValue(params).then(() => {
      dispatch("dictionary/fetchDictionaryValues", true, {root: true})
    }).catch((err) => {
      console.log(err)
    }).finally(async () => {
      await dispatch("loading/setLoading", false, {root: true})
    })
  },
}

// mutations
const mutations = {
  setDictionaries (state, dictionaries) {
    state.dictionaries = dictionaries
  },
  setDictionaryValues (state, dictionary_values) {
    state.dictionary_values = dictionary_values
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
